import { render, staticRenderFns } from "./CryptomatsRenters.vue?vue&type=template&id=35013f98&scoped=true&"
import script from "./CryptomatsRenters.vue?vue&type=script&lang=js&"
export * from "./CryptomatsRenters.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsRenters.vue?vue&type=style&index=0&id=35013f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35013f98",
  null
  
)

export default component.exports